<div class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">{{ 'invitedOrgs.title' | translate }}</h1>
      <p class="text-gray-600">{{ 'invitedOrgs.subtitle' | translate }}</p>
    </div>
    <button mat-stroked-button (click)="fetch()" class="!border-gray-300 !text-gray-700 hover:!bg-gray-50">
      <mat-icon class="mr-1">refresh</mat-icon>
      {{ 'invitedOrgs.refresh' | translate }}
    </button>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6" *ngIf="summary">
    <mat-card class="stat-card">
      <mat-card-content>
        <div class="stat-label">{{ 'invitedOrgs.statInvited' | translate }}</div>
        <div class="stat-value">{{ summary.totalInvited }}</div>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card">
      <mat-card-content>
        <div class="stat-label">{{ 'invitedOrgs.statOnboardingPending' | translate }}</div>
        <div class="stat-value">{{ summary.onboardingPending }}</div>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card">
      <mat-card-content>
        <div class="stat-label">{{ 'invitedOrgs.statOnboarded' | translate }}</div>
        <div class="stat-value">{{ summary.onboarded }}</div>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card">
      <mat-card-content>
        <div class="stat-label">{{ 'invitedOrgs.statWithSubscription' | translate }}</div>
        <div class="stat-value">{{ summary.withSubscription }}</div>
      </mat-card-content>
    </mat-card>
    <mat-card class="stat-card">
      <mat-card-content>
        <div class="stat-label">{{ 'invitedOrgs.statActiveSubscription' | translate }}</div>
        <div class="stat-value">{{ summary.activeSubscription }}</div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card class="mb-4">
    <mat-card-content>
      <mat-form-field class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'search' | translate }}</mat-label>
        <input matInput [(ngModel)]="search" (input)="applyFilter()" [placeholder]="'invitedOrgs.searchPlaceholder' | translate" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <div *ngIf="loading" class="flex items-center justify-center py-16">
    <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
  </div>

  <mat-card *ngIf="!loading">
    <mat-card-content>
      <div class="overflow-x-auto">
        <table mat-table [dataSource]="dataSource" matSort class="w-full">
          <ng-container matColumnDef="srNo">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
          </ng-container>

          <ng-container matColumnDef="org_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'invitedOrgs.colOrganization' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <div class="font-medium text-gray-900">{{ row.org_name }}</div>
              <div class="text-xs text-gray-500">{{ row.company_code }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="primary_contact_email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'invitedOrgs.colEmail' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.primary_contact_email }}</td>
          </ng-container>

          <ng-container matColumnDef="invitedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'invitedOrgs.colInvited' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.invitedAt | date:'medium' }}</td>
          </ng-container>

          <ng-container matColumnDef="invitedRole">
            <th mat-header-cell *matHeaderCellDef>{{ 'invitedOrgs.colRole' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.invitedRole || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="onboarding">
            <th mat-header-cell *matHeaderCellDef>{{ 'invitedOrgs.colOnboarding' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <span class="badge" [class.badge-ok]="row.onboardingCompleted" [class.badge-warn]="!row.onboardingCompleted">
                {{ onboardingLabel(row) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="subscription">
            <th mat-header-cell *matHeaderCellDef>{{ 'invitedOrgs.colSubscription' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.subscription; else noSub">
                <div class="text-sm font-medium">{{ row.subscription.status }}</div>
                <div class="text-xs text-gray-500">
                  {{ row.subscription.membership_start_date | date:'shortDate' }} → {{ row.subscription.membership_end_date | date:'shortDate' }}
                </div>
              </ng-container>
              <ng-template #noSub>—</ng-template>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
        </table>
      </div>

      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50]"
        showFirstLastButtons="true"
        class="mt-4"
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
